import PropTypes from 'prop-types';
import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { readEndpoint } from 'redux-json-api';

import AppBar from '@material-ui/core/AppBar';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Toolbar from '@material-ui/core/Toolbar';

import common from '@material-ui/core/es/colors/common';
import grey from '@material-ui/core/es/colors/grey';
import { withStyles } from '@material-ui/styles';

import BusRow from './BusRow';
import { selectActiveVehicles, selectInactiveVehicles } from './selectors';

class BusList extends Component {
  static propTypes = {
    // state props
    activeBuses: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.string.isRequired,
    })).isRequired,
    inactiveBuses: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.string.isRequired,
    })).isRequired,

    // dispatch props
    readEndpoint: PropTypes.func.isRequired,
  };

  state = {
    loading: true,
    showInactive: false,
  };

  componentWillMount() {
    const { readEndpoint } = this.props;

    readEndpoint('vehicle?filter[deleted-at__isnull]=True')
      .then(()=>this.setState({loading: false}));
  }

  handleToggle() {
    const { readEndpoint } = this.props;
    const { showInactive } = this.state;

    if (showInactive) {
      /**
       * Toggle from showing inactive users to active users.
       */
      this.setState({ showInactive: false, loading: true});

      readEndpoint('vehicle?filter[deleted-at__isnull]=True&filter[is-active__exact]=True')
        .then(()=>this.setState({loading: false}));
    } else {
      /**
       * Toggle from showing active users to inactive users.
       */
      this.setState({ showInactive: true, loading: true });

      readEndpoint('vehicle?filter[deleted-at__isnull]=True&filter[is-active__exact]=False')
        .then(()=>this.setState({loading: false}));
    }
  }

  render() {
    const { activeBuses, classes, inactiveBuses } = this.props;
    const { showInactive, loading } = this.state;

    const buses = showInactive ? inactiveBuses : activeBuses;

    return (
      <Fragment>
        <AppBar position="relative">
          <Toolbar variant="dense" className={classes.appBar}>
            <FormControlLabel
              classes={{ label: classes.toggleLabel }}
              control={
                <Switch
                  color="primary"
                  checked={showInactive}
                  onChange={e => this.handleToggle(e)}
                />
              }
              label="Inactief"
            />
          </Toolbar>
        </AppBar>

        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell>Voertuig#</TableCell>
              <TableCell>Kenteken</TableCell>
              <TableCell>Zitplaatsen</TableCell>
              <TableCell>Staplaatsen</TableCell>
              <TableCell>Euronorm</TableCell>
              <TableCell />
            </TableRow>
          </TableHead>

          <TableBody>
            {loading &&
              <TableRow>
                <TableCell colSpan={6}>Bezig met laden...</TableCell>
              </TableRow>
            }

            {buses.map(bus => <BusRow key={`bus-${bus.id}`} bus={bus} />)}
          </TableBody>
        </Table>
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  activeBuses: selectActiveVehicles(state),
  inactiveBuses: selectInactiveVehicles(state),
});

const mapDispatchToProps = { readEndpoint };

export default connect(mapStateToProps, mapDispatchToProps)(withStyles({
  appBar: {
    backgroundColor: grey[300],
  },
  toggleLabel: {
    color: common.black,
    opacity: 0.38,
    transition: 'opacity 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,color 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
  },
})(BusList));
